import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, TextField, Typography, Autocomplete } from '@mui/material';
import useStyles from './styles';
import { useFormik } from 'formik';
import { utilitySetupNewCustomProviderSchema } from 'src/utils/formValidation/AddNewProperty';
import { UtilityAccordion } from '../UtilityAccordion';
import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { ALLOCATION_METHOD, UTILITY_CONFIGURATION_TYPES, VACANT_UNIT_ALLOCATIONS, VACANT_UNIT_ALLOCATIONS_TO_PAID_BY, VACANT_UNIT_USAGE } from 'src/constants/utilities';
import { toJS } from 'mobx';
import { v4 as uuid } from 'uuid';
import { BackdropLoader
// Icon,
} from '@livable/saas-react-components';
import useModalFooterStyles from 'src/styles/cutomModalFooter';
import { isValueNumber } from 'src/utils/typeValidators';
export const AddProviderPlain = observer(_ref => {
  var _store$addNewProperty5, _store$addNewProperty6, _store$addNewProperty7, _store$addNewProperty8, _store$addNewProperty0, _store$addNewProperty1, _Object$keys;
  let handleClose = _ref.handleClose,
    provider = _ref.provider,
    isEditMode = _ref.isEditMode,
    propertyId = _ref.propertyId,
    hideNotEnabledExternal = _ref.hideNotEnabledExternal,
    onSave = _ref.onSave,
    _ref$customName = _ref.customName,
    customName = _ref$customName === void 0 ? '' : _ref$customName,
    isDetailsPage = _ref.isDetailsPage,
    isNewUtility = _ref.isNewUtility;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const modalFooterClasses = useModalFooterStyles();
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSavingProcessing = _useState4[0],
    setIsSavingProcessing = _useState4[1];
  const _useState5 = useState(store.addNewProperty.utilitiesSetupV2.getPropertySqFootage),
    _useState6 = _slicedToArray(_useState5, 2),
    buildingSquareFootageLocal = _useState6[0],
    setBuildingSquareFootageLocal = _useState6[1];
  const getSpinnerEnable = () => {
    return isLoading || store.utilityProviders.addCustomUtilityProvidersAsync.inProgress || store.properties.getPropertyAsync.inProgress || store.amenities.getAllCommonAreaAmenitiesRawAsync.inProgress || store.properties.addPropertyUtilityProviderAsync.inProgress || store.properties.addPropertyCommonAreaAmenityAsync.inProgress || store.properties.getPropertyUtilityProvidersV3Async.inProgress || store.utilityProviders.getUtilityProvidersAsync.inProgress || store.amenities.getAllAmenitiesRawAsync.inProgress || store.utilityProviders.getPropertyCommonAreaAmenitiesAsync.inProgress || store.buildings.getBuildingAsync.inProgress || store.properties.addPropertyUtilityProviderAsync.inProgress || store.properties.deletePropertyUtilityProvidersAsync.inProgress;
  };
  const resetNewProviderConfigurator = async () => {
    const resp = await store.utilityProviders.getAllUtilityTypesAsync.run({});
    store.addNewProperty.utilitiesSetupV2.setNewUtilityConfiguration({
      id: uuid(),
      name: '',
      website: '',
      utilities: resp.response.map(ut => {
        return {
          id: ut.utilityTypeId,
          utilityTypeId: ut.utilityTypeId,
          name: ut.utilityTypeName,
          isDefaultCAD: (ut === null || ut === void 0 ? void 0 : ut.cad) !== null && (ut === null || ut === void 0 ? void 0 : ut.cad),
          defaultAllocationMethod: typeof ut.defaultAllocationMethod === 'number' && [...Object.keys(ALLOCATION_METHOD)][ut.defaultAllocationMethod - 1] || null,
          defaultVacantUnitAllocation: VACANT_UNIT_ALLOCATIONS[ut.paidBy],
          defaultVacantUnitUsage: VACANT_UNIT_USAGE[ut.defaultVacantUnitUsage],
          vacantUnitUsage: VACANT_UNIT_USAGE[ut.defaultVacantUnitUsage],
          allocationMethod: typeof ut.defaultAllocationMethod === 'number' ? Object.keys(ALLOCATION_METHOD)[ut.defaultAllocationMethod - 1] : ALLOCATION_METHOD.ByOccupancy,
          utilityCAD: (ut === null || ut === void 0 ? void 0 : ut.cad) !== null && ut !== null && ut !== void 0 && ut.cad ? 5 : 0,
          vacantUnitAllocation: VACANT_UNIT_ALLOCATIONS[ut.paidBy]
        };
      })
    }, UTILITY_CONFIGURATION_TYPES.CustomUtilityProviderConfigurator);
  };
  const getCustomProviderUtilities = async () => {
    if (!isEditMode) {
      await resetNewProviderConfigurator();
    } else {
      store.addNewProperty.utilitiesSetupV2.setNewUtilityConfiguration(toJS(store.addNewProperty.utilitiesSetupV2.getPropertyProviderSetup(provider.id)), UTILITY_CONFIGURATION_TYPES.EditCustomUtilityProviderConfigurator);
    }
  };
  const addNewCustomUtility = () => {
    store.addNewProperty.utilitiesSetupV2.updateNewUtilityConfiguration([{
      utility: {
        id: "random_".concat(uuid()),
        utilityProviderId: isEditMode ? store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator.providerId : "random_".concat(uuid()),
        utilityProviderName: isEditMode ? store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator.providerName : store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator.providerName,
        utilityProviderWebSite: isEditMode ? store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator.utilityProviderWebSite : store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator.utilityProviderWebSite,
        utilityId: "random_".concat(uuid()),
        name: '',
        utilityCap: 0,
        utilityCAD: 5,
        isEnabled: true,
        isCustom: true,
        isDefaultCAD: true,
        defaultAllocationMethod: null,
        defaultVacantUnitAllocation: null,
        defaultVacantUnitUsage: null
      },
      values: undefined
    }], isEditMode ? UTILITY_CONFIGURATION_TYPES.EditCustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.CustomUtilityProviderConfigurator);
  };
  useEffect(() => {
    getCustomProviderUtilities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const addNewProviderFormik = useFormik({
    initialValues: provider || {
      name: customName,
      website: ''
    },
    validationSchema: utilitySetupNewCustomProviderSchema,
    onSubmit: async values => {
      try {
        setIsLoading(true);
        const name = values.name,
          website = values.website;
        if (name) {
          if (!isEditMode) {
            const currentConfiguratorState = toJS(store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator);
            const _await$store$utilityP = await store.utilityProviders.addCustomUtilityProvidersV2Async.run({
                name,
                website,
                propertyId,
                utilityTypeIds: currentConfiguratorState.utilities.filter(i => !i.isCustom).map(i => i.id)
              }),
              createdProviderId = _await$store$utilityP.response,
              isSuccessful = _await$store$utilityP.isSuccessful;
            if (isSuccessful) {
              const vendorExternalIdSnapshot = store.vendors.tempData.vendorExternalId;
              await resetNewProviderConfigurator();
              handleClose();
              const enabledUtils = currentConfiguratorState.utilities.filter(i => i.isEnabled).map(i => toJS(i));
              const customUtilitiesCreatedResp = await Promise.all(currentConfiguratorState.utilities.filter(i => i.isCustom).map(customUtil => {
                return store.utilityProviders.createCustomUtilityTypeAndAttachToProviderAsync.run({
                  name: customUtil.name,
                  defaultAllocationMethod: customUtil.allocationMethod,
                  defaultVacantUnitUsage: customUtil.vacantUnitUsage,
                  paidBy: VACANT_UNIT_ALLOCATIONS_TO_PAID_BY[customUtil.vacantUnitAllocation],
                  cad: customUtil.utilityCAD,
                  utilityProviderId: createdProviderId
                }).then(response => {
                  return _objectSpread({
                    customUtil
                  }, response);
                });
              }));
              const _await$store$utilityP2 = await store.utilityProviders.getUtilityProvidersAsync.run({
                  utilityProviderId: createdProviderId
                }),
                utilityProvider = _await$store$utilityP2.response;
              const providerUtilities = enabledUtils.map(enabUtil => {
                var _matchingProviderCust;
                const matchingProviderCustomUtility = customUtilitiesCreatedResp.find(i => i.customUtil.name === enabUtil.name);
                const matchingProviderUtility = utilityProvider.utilities.find(providerUtil => providerUtil.name === enabUtil.name);
                enabUtil.id = matchingProviderUtility.id;
                enabUtil.utilityProviderName = name;
                enabUtil.utilityProviderWebSite = website;
                enabUtil.utilityProviderId = createdProviderId;
                if (matchingProviderCustomUtility !== undefined && matchingProviderCustomUtility !== null && matchingProviderCustomUtility !== void 0 && matchingProviderCustomUtility.isSuccessful && matchingProviderCustomUtility !== null && matchingProviderCustomUtility !== void 0 && (_matchingProviderCust = matchingProviderCustomUtility.customUtil) !== null && _matchingProviderCust !== void 0 && _matchingProviderCust.isCustom) {
                  var _matchingProviderCust2, _matchingProviderCust3;
                  enabUtil.utilityId = matchingProviderCustomUtility === null || matchingProviderCustomUtility === void 0 || (_matchingProviderCust2 = matchingProviderCustomUtility.response) === null || _matchingProviderCust2 === void 0 ? void 0 : _matchingProviderCust2.utilityId;
                  enabUtil.utilityTypeId = matchingProviderCustomUtility === null || matchingProviderCustomUtility === void 0 || (_matchingProviderCust3 = matchingProviderCustomUtility.response) === null || _matchingProviderCust3 === void 0 ? void 0 : _matchingProviderCust3.utilityTypeId;
                  enabUtil.isCustom = false;
                }
                return enabUtil;
              });
              store.addNewProperty.utilitiesSetupV2.selectUtilities({
                utilities: [...providerUtilities]
              });
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              onSave && onSave({
                goNext: false,
                forceNextStep: false,
                propertySqFootage: buildingSquareFootageLocal,
                createdUtilityProviderId: createdProviderId,
                vendorExternalIdSnapshot
              });
            }
          } else {
            await setIsSavingProcessing(!isSavingProcessing);
            await store.addNewProperty.utilitiesSetupV2.saveEditedCustomProvider(toJS(store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator));
            await store.utilityProviders.editCustomUtilityProvidersAsync.run({
              name,
              website,
              providerId: provider.id,
              propertyId
            });
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            onSave && onSave({
              goNext: false,
              forceNextStep: false
            });
            handleClose();
          }
          setIsLoading(false);
        }
      } catch (e) {
        setIsLoading(false);
        throw e;
      }
    }
  });
  const validateAddProvider = () => {
    var _utilsWithSqFootage, _utilsWithSqFootage2, _addNewProviderFormik, _validUtils;
    let validUtils = [];
    let utilsWithSqFootage = [];
    if (isEditMode) {
      var _store$addNewProperty, _store$addNewProperty2;
      validUtils = (_store$addNewProperty = store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator) === null || _store$addNewProperty === void 0 || (_store$addNewProperty = _store$addNewProperty.utilities) === null || _store$addNewProperty === void 0 ? void 0 : _store$addNewProperty.filter(i => i.isEnabled);
      utilsWithSqFootage = (_store$addNewProperty2 = store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator) === null || _store$addNewProperty2 === void 0 || (_store$addNewProperty2 = _store$addNewProperty2.utilities) === null || _store$addNewProperty2 === void 0 ? void 0 : _store$addNewProperty2.filter(i => i.isEnabled && (i.allocationMethod === ALLOCATION_METHOD.BySquareFootage || i.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage));
    } else {
      var _store$addNewProperty3, _store$addNewProperty4;
      validUtils = (_store$addNewProperty3 = store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator) === null || _store$addNewProperty3 === void 0 || (_store$addNewProperty3 = _store$addNewProperty3.utilities) === null || _store$addNewProperty3 === void 0 ? void 0 : _store$addNewProperty3.filter(i => i.isEnabled);
      utilsWithSqFootage = (_store$addNewProperty4 = store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator) === null || _store$addNewProperty4 === void 0 || (_store$addNewProperty4 = _store$addNewProperty4.utilities) === null || _store$addNewProperty4 === void 0 ? void 0 : _store$addNewProperty4.filter(i => i.isEnabled && (i.allocationMethod === ALLOCATION_METHOD.BySquareFootage || i.allocationMethod === ALLOCATION_METHOD.By50Occupancy50SquareFootage));
    }
    const isSqFootageNotValid = ((_utilsWithSqFootage = utilsWithSqFootage) === null || _utilsWithSqFootage === void 0 ? void 0 : _utilsWithSqFootage.length) && ((_utilsWithSqFootage2 = utilsWithSqFootage) === null || _utilsWithSqFootage2 === void 0 ? void 0 : _utilsWithSqFootage2.length) !== 0 && isValueNumber(store.addNewProperty.utilitiesSetupV2.sqFootage) && Number(store.addNewProperty.utilitiesSetupV2.sqFootage) === 0 && isValueNumber(buildingSquareFootageLocal) && Number(buildingSquareFootageLocal);
    return ((_addNewProviderFormik = addNewProviderFormik.values.name) === null || _addNewProviderFormik === void 0 ? void 0 : _addNewProviderFormik.length) && (// addNewProviderFormik.values.website?.length &&
    (_validUtils = validUtils) === null || _validUtils === void 0 ? void 0 : _validUtils.length) && validUtils.filter(i => !(i !== null && i !== void 0 && i.name.length)).length === 0 && !isSqFootageNotValid;
  };
  return /*#__PURE__*/React.createElement("form", {
    className: classes.form,
    onSubmit: addNewProviderFormik.handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.formContentVariant
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: getSpinnerEnable()
  }), !isEditMode && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.enter_provider_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.xssSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    color: "light"
  }, t('add_new_property_flow.please_enter')))), isEditMode && /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.edit_provider_details')), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    rowSpacing: 24
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    id: "name",
    name: "name",
    label: t('add_new_property_flow.provider_name'),
    variant: "outlined",
    fullWidth: true,
    value: addNewProviderFormik.values.name,
    onBlur: e => {
      if (e.target.value) addNewProviderFormik.handleBlur(e);
    },
    onChange: e => {
      addNewProviderFormik.handleChange(e);
    },
    error: addNewProviderFormik.touched.name && Boolean(addNewProviderFormik.errors.name),
    helperText: addNewProviderFormik.touched.name && addNewProviderFormik.errors.name
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(TextField, {
    label: t('add_new_property_flow.provider_website'),
    id: "website",
    name: "website",
    variant: "outlined",
    fullWidth: true,
    value: addNewProviderFormik.values.website,
    onBlur: e => {
      if (e.target.value) addNewProviderFormik.handleBlur(e);
    },
    onChange: e => {
      addNewProviderFormik.handleChange(e);
    },
    error: addNewProviderFormik.touched.website && Boolean(addNewProviderFormik.errors.website),
    helperText: addNewProviderFormik.touched.website && addNewProviderFormik.errors.website
  })))), (!isEditMode || true) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.xlSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.please_setup_utilities'))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Autocomplete, {
    multiple: true,
    variant: "plain",
    id: "utilities-list",
    ChipProps: {
      // deleteIcon: <Icon type="close" />, // Breaks emeded delete event
      // onDelete: handleDelete,
      // icon: <Icon type="close" />, // Breaks emeded delete event
    },
    value: !isEditMode ? store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator && ((_store$addNewProperty5 = store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator) === null || _store$addNewProperty5 === void 0 || (_store$addNewProperty5 = _store$addNewProperty5.utilities) === null || _store$addNewProperty5 === void 0 ? void 0 : _store$addNewProperty5.filter(i => {
      var _i$name;
      return i.isEnabled && (i === null || i === void 0 || (_i$name = i.name) === null || _i$name === void 0 ? void 0 : _i$name.length);
    }).map(utility => {
      return _objectSpread(_objectSpread({}, utility), {}, {
        label: utility.name,
        id: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId),
        key: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId)
      });
    })) || [] : ((_store$addNewProperty6 = store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator) === null || _store$addNewProperty6 === void 0 ? void 0 : _store$addNewProperty6.utilities.filter(i => {
      var _i$name2;
      return i.isEnabled && (i === null || i === void 0 || (_i$name2 = i.name) === null || _i$name2 === void 0 ? void 0 : _i$name2.length);
    }).map(utility => {
      return _objectSpread(_objectSpread({}, utility), {}, {
        label: utility.name,
        id: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId),
        key: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId)
      });
    })) || [],
    options: isEditMode ? ((_store$addNewProperty7 = store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator) === null || _store$addNewProperty7 === void 0 || (_store$addNewProperty7 = _store$addNewProperty7.utilities) === null || _store$addNewProperty7 === void 0 ? void 0 : _store$addNewProperty7.filter(i => !i.isEnabled).map(utility => {
      return _objectSpread(_objectSpread({}, utility), {}, {
        id: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId),
        key: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId),
        label: utility.name
      });
    })) || [] : ((_store$addNewProperty8 = store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator) === null || _store$addNewProperty8 === void 0 || (_store$addNewProperty8 = _store$addNewProperty8.utilities) === null || _store$addNewProperty8 === void 0 ? void 0 : _store$addNewProperty8.filter(i => !i.isEnabled).map(utility => {
      return _objectSpread(_objectSpread({}, utility), {}, {
        id: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId),
        key: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId),
        label: utility.name
      });
    })) || [],
    filterSelectedOptions: true,
    renderInput: params => /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
      label: t('add_new_property_flow.utilities')
    })),
    onChange: (e, value, situation, option) => {
      switch (situation) {
        case 'blur':
          {
            // console.log('situation', situation, value, option);
            break;
          }
        case 'createOption':
          {
            // console.log('situation', situation, value, option);
            break;
          }
        case 'clear':
          {
            var _store$addNewProperty9;
            // // disable all
            // console.log(
            //   'situation clear',
            //   situation,
            //   value,
            //   option
            // );
            const isCustomProvider = true;
            const clearArr = (_store$addNewProperty9 = store.addNewProperty.utilitiesSetupV2[isEditMode ? 'getEditCustomUtilityProviderConfigurator' : 'getCustomUtilityProviderConfigurator']) === null || _store$addNewProperty9 === void 0 ? void 0 : _store$addNewProperty9.utilities.filter(i => i.isEnabled).map(i => {
              return {
                values: [{
                  key: 'isEnabled',
                  value: false
                }],
                utility: i
              };
            });
            store.addNewProperty.utilitiesSetupV2.updateNewUtilityConfiguration(clearArr, isCustomProvider ? isEditMode ? UTILITY_CONFIGURATION_TYPES.EditCustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.CustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.UtilityConfigurator);
            break;
          }
        case 'selectOption':
          {
            // enable utility
            // console.log(
            //   'situation selectOption',
            //   situation,
            //   value,
            //   option
            // );
            const isCustomProvider = true;
            store.addNewProperty.utilitiesSetupV2.updateNewUtilityConfiguration([{
              values: [{
                key: 'isEnabled',
                value: true
              }],
              utility: option.option
            }], isCustomProvider ? isEditMode ? UTILITY_CONFIGURATION_TYPES.EditCustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.CustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.UtilityConfigurator);
            break;
          }
        case 'removeOption':
          {
            // disable utility
            // console.log(
            //   'situation removeOption',
            //   situation,
            //   value,
            //   option
            // );
            const isCustomProvider = true;
            store.addNewProperty.utilitiesSetupV2.updateNewUtilityConfiguration([{
              values: [{
                key: 'isEnabled',
                value: false
              }],
              utility: option.option
            }], isCustomProvider ? isEditMode ? UTILITY_CONFIGURATION_TYPES.EditCustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.CustomUtilityProviderConfigurator : UTILITY_CONFIGURATION_TYPES.UtilityConfigurator);
            break;
          }
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, !isEditMode ? store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator && ((_store$addNewProperty0 = store.addNewProperty.utilitiesSetupV2.getCustomUtilityProviderConfigurator) === null || _store$addNewProperty0 === void 0 ? void 0 : _store$addNewProperty0.utilities.filter(i => i === null || i === void 0 ? void 0 : i.isEnabled).map(utility => /*#__PURE__*/React.createElement(UtilityAccordion, {
    utility: utility,
    key: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId) || (utility === null || utility === void 0 ? void 0 : utility.utilityId),
    propertyId: propertyId,
    isCustomProvider: true,
    hideNotEnabled: hideNotEnabledExternal,
    enableRemove: true,
    disableToggler: true
    // utilityIsEnabledByDefault
    ,
    isEdit: isEditMode,
    isDetailsPage: isDetailsPage,
    isNewUtility: isNewUtility,
    customMode: utility === null || utility === void 0 ? void 0 : utility.isCustom,
    setBuildingSquareFootageLocalExternal: setBuildingSquareFootageLocal,
    propertySqFootageExternal: buildingSquareFootageLocal
  }))) : store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator && ((_store$addNewProperty1 = store.addNewProperty.utilitiesSetupV2.getEditCustomUtilityProviderConfigurator) === null || _store$addNewProperty1 === void 0 ? void 0 : _store$addNewProperty1.utilities.filter(i => i === null || i === void 0 ? void 0 : i.isEnabled).map(utility => /*#__PURE__*/React.createElement(UtilityAccordion, {
    utility: utility,
    key: (utility === null || utility === void 0 ? void 0 : utility.id) || (utility === null || utility === void 0 ? void 0 : utility.utilityTypeId) || (utility === null || utility === void 0 ? void 0 : utility.utilityId),
    propertyId: propertyId,
    isCustomProvider: true,
    hideNotEnabled: hideNotEnabledExternal,
    enableRemove: true,
    disableToggler: true
    // utilityIsEnabledByDefault
    ,
    isEdit: isEditMode,
    isDetailsPage: isDetailsPage,
    customMode: provider.isCustom && utility.isCustom,
    triggerSaving: isSavingProcessing,
    setBuildingSquareFootageLocalExternal: setBuildingSquareFootageLocal,
    propertySqFootageExternal: buildingSquareFootageLocal
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    size: "small",
    onClick: addNewCustomUtility,
    'custom-attribute': '153-add-provider-modal-v2'
  }, t('add_new_property_flow.add_custom_utility'))))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.modalFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerEven
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: handleClose,
    'custom-attribute': '154-add-provider-modal-v2'
  }, t('buttons.cancel'))), /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: modalFooterClasses.footerButton
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "priority",
    type: "submit",
    disabled: getSpinnerEnable() || !validateAddProvider() || ((_Object$keys = Object.keys(addNewProviderFormik.errors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length),
    'custom-attribute': '155-add-provider-modal-v2'
  }, getSpinnerEnable() ? t('general.saving') : provider && provider.name ? t('buttons.save_changes') : t('add_new_property_flow.add_new_provider')))))));
});